
























import Vue from 'vue';
import { Product } from '@/types';
import ProductChip from '../chips/ProductChip.vue';

type Data = {
  model: Product | null;
  items: Product[],
  isLoading: boolean,
  search: string | null
}

export default Vue.extend({
  components: {ProductChip},
  props: ['value', 'errorMessages'],
  data(): Data {
    return {
      model: null,
      items: [],
      isLoading: false,
      search: null
    };
  },
  computed: {
    selectedId(): number | null {
      return this.value ? Number(this.value) : null;
    }
  },
  watch: {
    search() {
      this.load();
    }
  },
  methods: {
    async load() {
      this.isLoading = true;
      this.$store.api.products({
        where: {
          search: this.search || undefined
        },
        page: 1,
        perPage: 10
      }).then(res => {
        this.items = res.items;
        if (this.selectedId) {
          return this.$store.api.product(this.selectedId).then(it => {
            this.items.unshift(it);
          });
        }
      }).catch(this.setError).then(() => { this.isLoading = false; });
    },
    removeSelected() {
      this.$emit('input', null);
    },
    onInput(ev: unknown) {
      this.$emit('input', ev);
    }
  },
  mounted() {
    this.load();
  }
});
